import Axios from 'axios/index';
import CredentialsHelper from './credentials-helper';
import { general, urls } from '../settings';

const ERROR_504_MAX_RETRY = 10; // 300 seconds or 5 minutos

export const getJson = (url, params = {}, count = 0) => {
    return Axios
        .get(url, { headers: authorizedHeaders(CredentialsHelper.accessToken), params })
        .catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        return handleTokenIssue().then(() => getJson(url, params, count));
                    case 504:
                        if (count < ERROR_504_MAX_RETRY) {
                            return getJson(url, params, ++count);
                        }
                        break;
                    default:
                        break;
                }
            }

            throw error;
        });
};
export const patchJson = (url, data, params = {}, count = 0) => {
    return Axios
        .patch(url, data, { headers: authorizedHeaders(CredentialsHelper.accessToken), params })
        .catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        return handleTokenIssue().then(() => patchJson(url, data, params, count));
                    case 504:
                        if (count < ERROR_504_MAX_RETRY) {
                            return patchJson(url, data, params, ++count);
                        }
                        break;
                    default:
                        break;
                }
            }

            throw error;
        });
};

export const postJson = (url, data, params = {}, count = 0) => {
    return Axios
        .post(url, data, { headers: authorizedHeaders(CredentialsHelper.accessToken), params })
        .catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        return handleTokenIssue().then(() => postJson(url, data, params, count));
                    case 504:
                        if (count < ERROR_504_MAX_RETRY) {
                            return postJson(url, data, params, ++count);
                        }
                        break;
                    default:
                        break;
                }
            }

            throw error;
        });
};

export const putJson = (url, data, { headers }, count = 0) => {
    return Axios
        .put(url, data, { headers: { ...authorizedHeaders(CredentialsHelper.accessToken), ...headers } })
        .catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        return handleTokenIssue().then(() => putJson(url, data, { headers }, count));
                    case 504:
                        if (count < ERROR_504_MAX_RETRY) {
                            return putJson(url, data, { headers }, ++count);
                        }
                        break;
                    default:
                        break;
                }
            }

            throw error;
        });
};

export const deleteJson = (url, params = {}, count = 0) => {
    return Axios
        .delete(url, { headers: authorizedHeaders(CredentialsHelper.accessToken), params })
        .catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        return handleTokenIssue().then(() => deleteJson(url, params, count));
                    case 504:
                        if (count < ERROR_504_MAX_RETRY) {
                            return deleteJson(url, params, ++count);
                        }
                        break;
                    default:
                        break;
                }
            }

            throw error;
        });
};

export const requestToken = (optionalData = {}) => {
    const data = { ...defaultTokenData, ...optionalData };
    return Axios
        .post(urls.LOGIN, data, { headers: authorizedHeadersWithNoToken() });
};

const authorizedHeadersWithNoToken = () => ({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
});

const authorizedHeaders = (token) => ({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + token,
});

const handleTokenIssue = debouncePromise(() => refreshToken()
    .then(({ data }) => CredentialsHelper.update(data.access_token, data.refresh_token))
    .catch(error => {
        CredentialsHelper.clear();
        throw error;
    })
);

const DEBOUNCE_TIME = 5000;

function debouncePromise(fn) {
    const reset = () => setTimeout(() => promise = null, DEBOUNCE_TIME);
    let promise = null;

    return (...args) => {
        if (promise === null) {
            promise = fn(...args);
            promise
                .then(reset, reset);
        }
        return promise;
    };
}

const refreshToken = () => requestToken({
    grant_type: 'refresh_token',
    refresh_token: CredentialsHelper.refreshToken,
});

const defaultTokenData = {
    grant_type: 'password',
    client_id: general.client_id,
    scope: 'ead',
    machine: navigator.userAgent,
};



// WEBPACK FOOTER //
// ./src/utils/http-json-service.js